import { render, staticRenderFns } from "./ELabel.vue?vue&type=template&id=0491a36b"
import script from "./ELabel.vue?vue&type=script&lang=js"
export * from "./ELabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports